// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedBuilderRoute from "./components/ProtectedBuilderRoute";
import ProtectedAdminRoute from "./Admin/components/Auth/ProtectedAdminRoute";
import TestAPI from "./TestAPI";
import TestSaveFeatures from "./TestSaveFeatures";

// admin 

import ScrollToTop from "./Admin/components/ScrollToTop";
import Splash from "./Admin/components/Auth/SplashScreen";


import AdminCRMOpenLead from "./Admin/components/CRMOpenLead";
import AdminCRM from "./Admin/components/AdminCRM";
import AdminPopularBuilder from "./Admin/components/PopularBuilder"
import AdminPopularAgents from "./Admin/components/PopularAgents"
import AdminPopularAgencies from "./Admin/components/PopularAgencies"
import AdminPopularProjects from "./Admin/components/PopularProjects"
import AdminPopularLocations from "./Admin/components/PopularLocations"
import AdminPopularpropertytypes from "./Admin/components/Popularpropertytypes"
import AdminPopularcommunitytypes from "./Admin/components/Popularcommunitytypes"
import AdminPopularPropertySpecs from "./Admin/components/Popularpropertyspecs";
import Adminmanageuser from "./Admin/components/Webadminmanageuser"
import AdminNotification from "./Admin/components/Notificationswebadmin"
import AdminTaskScreen from "./Admin/components/TaskScreenwebadmin"
import AdminTask from "./Admin/components/AdminTask"
import AdminTaskTest from "./AdminTaskTest"
import TaskAPITest from "./TaskAPITest"
import SimpleTest from "./SimpleTest"
import Adminwebsubscriptionmonthly from "./Admin/components/Adminwebsubscriptionmonthly"
import AdminPushNotification from "./Admin/components/PushNotification"
import AdminPushNotificationReports from "./Admin/components/PushNotificationReports"

import AdminChangePassword from "./Admin/components/Account Settings/ChangePassword"
import AdminFAQAccordion from "./Admin/components/Account Settings/FAQAccordion"
import AdminForgotPassword from "./Admin/components/Account Settings/ForgotPassword"
import AdminHelpSupport from "./Admin/components/Account Settings/HelpSupport"
import AdminPersonalinformation from "./Admin/components/Account Settings/PersonalInformation"
import AdminAgencyProfile from "./Admin/components/Account Settings/AgencyProfile"
import AdminAgentProfile from "./Admin/components/Account Settings/AgentProfile"
import AdminAgencyViewBuilder from "./Admin/components/Account Settings/AgencyViewBuilder"
import AdminCrmUserMenu from "./Admin/components/Account Settings/AdminCrmUserMenu"
import AdminCrmBillingSummary from "./Admin/components/Account Settings/AdminCrmBillingSummary"
import AdminCrmManageProjects from "./Admin/components/Account Settings/AdminCrmManageProjects"
import AdminCrmAddProject from "./Admin/components/Account Settings/AdminCrmAddProject"
import AdminCrmMandateProjects from "./Admin/components/Account Settings/AdminCrmMandateProjects"
import AdminCrmListings from "./Admin/components/Account Settings/AdminCrmListings"
import AdminCrmPersonalInfo from "./Admin/components/Account Settings/AdminCrmPersonalInfo"
import AdminCrmProfessionalIds from "./Admin/components/Account Settings/AdminCrmProfessionalIds"
import AdminCrmReviews from "./Admin/components/Account Settings/AdminCrmReviews"
import AdminCrmStaffActivityLogs from "./Admin/components/Account Settings/AdminCrmStaffActivityLogs"
import AdminConfig from "./Admin/components/AdminConfig"
import Admindashboard from "./Admin/components/Webadmindashboard"
import Adminaddcrm from "./Admin/components/Webadminaddcrm"
import Adminprofile from "./Admin/components/Webadminprofile"
import Adminbillingsummary1 from "./Admin/components/Webadminbillingsummary"
import Admincontact from "./Admin/components/Webadmincontact"
import AdminForgotpassword from "./Admin/components/AdminForgotpassword"
// import ScrollToTop from "./builder/components/ScrollToTop";
import Adminagentandagency from "./Admin/components/Adminagentandagency"
import AdminBuilderpopup from "./Admin/components/AdminBuilderpopup"
import AdminLogin from './Admin/components/AdminLogin'
import Adminregistration from './Admin/components/Adminregistration'
import BuilderProjectDetails from "./Admin/components/ProjectDetails";
import Policies from "./Admin/components/Account Settings/policies"
import { CrmSessionAdminProvider } from "./Admin/components/CrmSessionAdminContext";
function App() {
  return (
    <CrmSessionAdminProvider>
    <Router>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Splash />} />

        {/* Public Admin Routes */}
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/AdminForgotpassword" element={<AdminForgotpassword />} />
        <Route path="/Adminregistration" element={<Adminregistration />} />

        {/* ── All-role authenticated routes ── */}
        <Route path="/adminprofile" element={<ProtectedAdminRoute><Adminprofile /></ProtectedAdminRoute>} />
        <Route path="/AdminChangePassword" element={<ProtectedAdminRoute><AdminChangePassword /></ProtectedAdminRoute>} />
        <Route path="/AdminFAQAccordion" element={<ProtectedAdminRoute><AdminFAQAccordion /></ProtectedAdminRoute>} />

        {/* ── Dashboard → admin + dashboard_view ── */}
        <Route path="/Webadmindashboard" element={<ProtectedAdminRoute allowedRoles={['admin', 'dashboard_view']}><Admindashboard /></ProtectedAdminRoute>} />

        {/* ── Task Manager → admin + customer_support ── */}
        <Route path="/TaskScreenwebadmin" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminTaskScreen /></ProtectedAdminRoute>} />
        <Route path="/admin-projectdetails/:id" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><BuilderProjectDetails /></ProtectedAdminRoute>} />

        {/* ── CRM → admin + customer_support ── */}
        <Route path="/Webadminaddcrm" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><Adminaddcrm /></ProtectedAdminRoute>} />
        <Route path="/AdminCRM" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCRM /></ProtectedAdminRoute>} />
        <Route path="/admin-crm-lead/:id" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCRMOpenLead /></ProtectedAdminRoute>} />
        <Route path="/Adminagentandagency" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><Adminagentandagency /></ProtectedAdminRoute>} />
        <Route path="/AdminAgencyProfile" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminAgencyProfile /></ProtectedAdminRoute>} />
        <Route path="/AdminAgentProfile" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminAgentProfile /></ProtectedAdminRoute>} />
        <Route path="/AdminAgencyViewBuilder" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminAgencyViewBuilder /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmUserMenu" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmUserMenu /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmBillingSummary" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmBillingSummary /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmManageProjects" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmManageProjects /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmAddProject" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmAddProject /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmMandateProjects" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmMandateProjects /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmListings" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmListings /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmPersonalInfo"element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmPersonalInfo /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmProfessionalIds" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmProfessionalIds /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmReviews" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmReviews /></ProtectedAdminRoute>} />
        <Route path="/AdminCrmStaffActivityLogs" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminCrmStaffActivityLogs /></ProtectedAdminRoute>} />
        <Route path="/AdminBuilderpopup" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><AdminBuilderpopup /></ProtectedAdminRoute>} />

        {/* ── Contacts/Chat → admin + customer_support ── */}
        <Route path="/Webadmincontact" element={<ProtectedAdminRoute allowedRoles={['admin', 'customer_support']}><Admincontact /></ProtectedAdminRoute>} />

        {/* ── Push Notifications → admin + marketing ── */}
        <Route path="/AdminPushNotification" element={<ProtectedAdminRoute allowedRoles={['admin', 'marketing']}><AdminPushNotification /></ProtectedAdminRoute>} />
        <Route path="/PushNotificationReports" element={<ProtectedAdminRoute allowedRoles={['admin', 'marketing']}><AdminPushNotificationReports /></ProtectedAdminRoute>} />

        {/* ── Notifications (bell in TopNav) → all admin roles ── */}
        <Route path="/Notificationwebadmin" element={<ProtectedAdminRoute allowedRoles={['admin', 'marketing', 'customer_support', 'dashboard_view', 'accounts']}><AdminNotification /></ProtectedAdminRoute>} />

        {/* ── Billing → accounts only ── */}
        <Route path="/adminbillingsummary" element={<ProtectedAdminRoute allowedRoles={['admin', 'accounts']}><Adminbillingsummary1 /></ProtectedAdminRoute>} />

        {/* ── Admin-only routes ── */}
        <Route path="/Webadminmanageuser" element={<ProtectedAdminRoute allowedRoles={['admin']}><Adminmanageuser /></ProtectedAdminRoute>} />
        <Route path="/Adminwebsubscriptionmonthly" element={<ProtectedAdminRoute allowedRoles={['admin']}><Adminwebsubscriptionmonthly /></ProtectedAdminRoute>} />
        <Route path="/AdminConfig" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminConfig /></ProtectedAdminRoute>} />
        <Route path="/AdminHelpSupport" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminHelpSupport /></ProtectedAdminRoute>} />
        <Route path="/ Personalinformation" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPersonalinformation /></ProtectedAdminRoute>} />
        <Route path="/PopularBuilder" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularBuilder /></ProtectedAdminRoute>} />
        <Route path="/PopularAgents" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularAgents /></ProtectedAdminRoute>} />
        <Route path="/PopularAgencies" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularAgencies /></ProtectedAdminRoute>} />
        <Route path="/PopularProjects" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularProjects /></ProtectedAdminRoute>} />
        <Route path="/PopularLocations" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularLocations /></ProtectedAdminRoute>} />
        <Route path="/Popularpropertytypes" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularpropertytypes /></ProtectedAdminRoute>} />
        <Route path="/Popularcommunitytypes" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularcommunitytypes /></ProtectedAdminRoute>} />
        <Route path="/PopularPropertySpecs" element={<ProtectedAdminRoute allowedRoles={['admin']}><AdminPopularPropertySpecs /></ProtectedAdminRoute>} />
        <Route path="/Policies" element={<ProtectedAdminRoute allowedRoles={['admin']}><Policies /></ProtectedAdminRoute>} />
        {/* ── Builder protected routes (non-admin) ── */}
        <Route path="/builder-projectdetails/:id" element={<ProtectedBuilderRoute><BuilderProjectDetails /></ProtectedBuilderRoute>} />

        {/* ── Dev/test routes (unprotected) ── */}
        <Route path="/AdminTask" element={<AdminTask />} />
        <Route path="/AdminTaskTest" element={<AdminTaskTest />} />

        {/* Test API Routes */}
        <Route path="/test-api" element={<TestAPI />} />
        <Route path="/test-save" element={<TestSaveFeatures />} />
        <Route path="/TaskAPITest" element={<TaskAPITest />} />
        <Route path="/SimpleTest" element={<SimpleTest />} />

      </Routes>

    </Router>
    </CrmSessionAdminProvider>
  );
}

export default App;
